import styles from './DateCard.module.scss';
import { Tooltip } from '@Components/Tooltip/Tooltip';
import { RiQuestionLine, RiCalendarEventLine } from 'react-icons/ri';
import { formatDate } from '@Helpers/formatDate';

interface DateCardProps {
  date: string;
  title: string;
  tooltip?: string;
}

export const DateCard = ({ date, title, tooltip }: DateCardProps) => {
  return (
    <div className={styles.container}>
      <RiCalendarEventLine size={24} />
      <div className={styles.titleContainer}>
        <p className={styles.title}>{title}</p>
        {tooltip && (
          <Tooltip title={tooltip as string}>
            <div className={styles.helpIcon}>
              <RiQuestionLine />
            </div>
          </Tooltip>
        )}
      </div>
      <p className={styles.date}>{formatDate(date)}</p>
    </div>
  );
};
